import Header from "@shared/components/Header";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const ThankYou: React.FC<{ accountConfirmiation?: boolean }> = ({
  accountConfirmiation = false,
}) => {
  const navigate = useNavigate();

  const location = useLocation();
  const masked_email = location.state?.data;

  return (
    <div className="flex flex-col h-screen w-full">
      {" "}
      <Header />
      <div className="flex-1 w-full items-center justify-center flex">
        <div className="flex flex-col items-center justify-center gap-4 mb-28">
          <img src="/thank_you.svg" alt="" />
          <div className="text-center max-w-4xl">
            <h1 className="text-2xl mb-2">
              Thank you for your Interest in THE ARK.
            </h1>
            {accountConfirmiation ? (
              <p className="text-gray-400">
                Our team will review your application and get back to you as
                soon as possible.
                <br /> In the meantime, if you have any questions, feel free to
                reach out to us at{" "}
                <span className="text-blue-500">support@theark.co</span> <br />—
                we're here to help!
              </p>
            ) : (
              <p className="text-gray-400">
                Thank you, your organisation is already registered on the
                platform. We have sent an email to your workspace
                <br /> admin{" "}
                <span className="text-blue-500">{masked_email}</span> to approve
                your access. Once they do, you will be notified.
              </p>
            )}
            <button
              onClick={() => {
                navigate("/login");
              }}
              className="bg-blue-600 text-white py-2 px-4 mt-4 rounded-md cursor-pointer font-medium hover:bg-blue-700"
            >
              Return to Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
